import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button } from "@mui/material";

export default function DialogInutilizarProposta({ aberto, onCancelar, onConfirmar }) {
  const [motivo, setMotivo] = useState("");

  useEffect(() => {
    if (aberto) setMotivo("");
  }, [aberto]);

  return (
    <Dialog
      open={aberto}
      onClose={onCancelar}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundColor: "var(--ig-f-1e1e1e)", color: "var(--ig-t-ffffff)" } }}
    >
      <DialogTitle sx={{ color: "var(--ig-t-ffffff)" }}>Inutilizar Proposta</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
        <DialogContentText sx={{ color: "var(--ig-t-aaaaaa)" }}>
          Propostas não podem ser excluídas. Informe o motivo pelo qual esta proposta será inutilizada — esta ação não pode ser desfeita.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          size="small"
          multiline
          rows={6}
          label="Motivo *"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          helperText={`${motivo.length}/255`}
          slotProps={{ htmlInput: { maxLength: 255 } }}
          sx={{
            "& .MuiInputLabel-root": { color: "var(--ig-t-ffffff)" },
            "& .MuiOutlinedInput-root": {
              backgroundColor: "var(--ig-f-2a2a2a)",
              color: "var(--ig-t-ffffff)",
              "& fieldset": { borderColor: "var(--ig-b-444444)" },
              "&:hover fieldset": { borderColor: "var(--ig-b-888888)" },
            },
            "& textarea": { color: "var(--ig-t-ffffff)" },
            "& .MuiFormHelperText-root": { color: "var(--ig-t-888888)" },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onCancelar}>
          Cancelar
        </Button>
        <Button variant="contained" color="error" onClick={() => onConfirmar(motivo)}>
          Inutilizar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
